import { get } from 'lodash';
export const selectCommonAreas = state => get(state, 'commonAreas', []);